import Head from 'next/head';
import { useRouter } from 'next/router';

import { getPublicAsPath, replaceQueryParamAsOnly, urlObjectToString } from '../../utils/routing';

export const PaginationMetaLink = ({
  page = 1,
  totalPages,
  queryName,
}: {
  page?: number;
  totalPages: number;
  queryName: string;
}) => {
  const { pathname, query, basePath } = useRouter();

  if (typeof page !== 'number') return null;

  // `router.asPath` renverrait le chemin INTERNE post-rewrite (slug du tenant, basePath omis)
  // → `<link>` en 404. On repart du chemin PUBLIC reconstruit (cf. getPublicAsPath).
  const publicAsPath = getPublicAsPath(pathname, query, basePath);

  return (
    <Head>
      {page > 1 && page <= totalPages + 1 && (
        <link
          rel="prev"
          href={urlObjectToString(
            replaceQueryParamAsOnly(publicAsPath, queryName, page > 2 ? page - 1 : null),
          )}
        />
      )}
      {page > -1 && page < totalPages && (
        <link
          rel="next"
          href={urlObjectToString(replaceQueryParamAsOnly(publicAsPath, queryName, page + 1))}
        />
      )}
    </Head>
  );
};
